import { useTranslation } from "react-i18next";
import { Header, Paragraph } from "@datagame/ui";

import { AuthPageLayout } from "../../../components/account/AuthPageLayout";
import { LoginForm } from "../../../components/account/LoginForm";

import styles from "./LoginPage.module.scss";

export const LoginPage = () => {
  const { t } = useTranslation("account");
  return (
    <AuthPageLayout>
      <div>
        <Header variant="h5" className={styles.h5}>
          {t("loginPage.header")}
        </Header>
        <Header variant="h1" className={styles.header}>
          {t("loginPage.loginTo")} <span className={styles.orangeText}>{t("loginPage.datagame")}</span>
        </Header>

        <Paragraph color="secondary" className={styles.body}>
          {t("loginPage.description")}
        </Paragraph>
      </div>
      <LoginForm />
    </AuthPageLayout>
  );
};
